
<script context="module">

import { 
  VmControls 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-controls', VmControls);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className = '';

export let style = '';
export { className as class };

export let hidden = false;
export let fullWidth = false;
export let fullHeight = false;
export let direction = 'row';
export let align = 'center';
export let justify = 'start';
export let pin = 'bottomLeft';
export let activeDuration = 2750;
export let waitForPlaybackStart = false;
export let hideWhenPaused = false;
export let hideOnMouseLeave = false;
export let isAudioView = false;
export let isSettingsActive = false;
export let playbackReady = false;
export let isControlsActive = false;
export let paused = true;
export let playbackStarted = false;

export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => {
  

  __mounted = true;
});



const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-controls
  class={className}
  style={style}
  hidden={hidden}
  full-width={fullWidth}
  full-height={fullHeight}
  direction={direction}
  align={align}
  justify={justify}
  pin={pin}
  active-duration={activeDuration}
  wait-for-playback-start={waitForPlaybackStart}
  hide-when-paused={hideWhenPaused}
  hide-on-mouse-leave={hideOnMouseLeave}
  is-audio-view={isAudioView}
  is-settings-active={isSettingsActive}
  playback-ready={playbackReady}
  is-controls-active={isControlsActive}
  paused={paused}
  playback-started={playbackStarted}
  
  bind:this={__ref}
>
  <slot></slot>
</vm-controls>
  